import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import Slider from '../../components/slider';
import './styles.css';
import ScrollLoader from '../../components/scroll-loader';

/**
 *  Slideshow
 */
class Slideshow extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    mbBackgroundColor: PropTypes.string,
    position: PropTypes.string,
    pcSrc: PropTypes.array,
    mbSrc: PropTypes.array,
    pcSize: PropTypes.string,
    mbSize: PropTypes.string,
    duration: PropTypes.number,
    loop: PropTypes.bool,
    photoInfo: PropTypes.arrayOf(PropTypes.node),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    pcDescription: null,
    mbDescription: null,
    mbBackgroundColor: null,
    position: null,
    pcSrc: null,
    mbSrc: null,
    pcSize: null,
    mbSize: null,
    duration: null,
    loop: null,
    photoInfo: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      pcDescription,
      mbDescription,
      mbBackgroundColor,
      position,
      pcSrc,
      mbSrc,
      pcSize,
      mbSize,
      duration,
      loop,
      photoInfo,
    } = this.props;
    const settings = {
      autoplay: true,
      autoplaySpeed: duration + 3000,
      pauseOnHover: false,
      speed: 3000,
      ease: 'linear',
      fade: true,
      infinite: loop,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: false,
      draggable: false,
      arrows: false,
      dots: false,
      adaptiveHeight: false,
      centerMode: false,
      centerPadding: 0,
      lazyLoad: 'progressive',
      //lazyLoad: 'ondemand',
    };
    
    //
    const getPcDescription = () => {
      if (pcDescription && pcDescription !== '') {
        return pcDescription;
      } else {
        return null;
      }
    };
    
    //
    const getMbDescription = () => {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };
    
    //
    const getPcSrc = (index) => {
      if (pcSrc && Array.isArray(pcSrc) && 1 <= pcSrc.length && pcSrc[index]) {
        return pcSrc[index];
      } else {
        return null;
      }
    };
    
    //
    const getMbSrc = (index) => {
      if (mbSrc && Array.isArray(mbSrc) && 1 <= mbSrc.length && mbSrc[index]) {
        return mbSrc[index];
      } else {
        return getPcSrc(index);
      }
    };
    
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <ScrollLoader>
          <div
            className={'Slideshow' + ((pcSize && pcSize !== '') ? ' ' + pcSize + '_pc': '') + ((mbSize && mbSize !== '') ? ' ' + mbSize + '_mb': '')}
            style={{backgroundColor: ((mbBackgroundColor && mbBackgroundColor !== '') ? mbBackgroundColor: '#101010')}}
          >
            <div className="Slideshow__container">
              {(() => {
                if (getPcDescription()) {
                  return (
                    <div className={'Slideshow__description' + ((position && position !== '') ? ' ' + position: '')}>
                      <div className="Slideshow__description-inner">
                        <div className="Slideshow__description-inner2">
                          <div className="Slideshow__description-pc Wysiwyg"
                               dangerouslySetInnerHTML={{__html: getPcDescription()}}
                          />
                          <div className="Slideshow__description-mb Wysiwyg"
                               dangerouslySetInnerHTML={{__html: getMbDescription()}}
                          />
                        </div>
                      </div>
                    </div>
                  )
                }
              })()}
              <Slider
                className="Slideshow__carousel"
                settings={settings}
              >
                {pcSrc.map((child, index) => {
                  return (
                    <div className="Slideshow__carousel-item"
                         key={index}
                    >
                      <div className="Slideshow__carousel-item-inner_pc"
                           style={{backgroundImage: 'url(' + getPcSrc(index) + ')'}}
                      />
                      <div className="Slideshow__carousel-item-inner_mb"
                           style={{backgroundImage: 'url(' + getMbSrc(index) + ')'}}
                      />
                    </div>
                  )
                })}
              </Slider>
            </div>
            {(photoInfo && Array.isArray(photoInfo) && 1 <= photoInfo.length) ? photoInfo: null}
          </div>
        </ScrollLoader>
      </Wrapper>
    )
    
  }
  
}

export default Slideshow;



// WEBPACK FOOTER //
// ./src/containers/slideshow/index.jsx